import * as cookieManager from './cookie'
import { getItem, setItem, removeItem } from './localStorage'
const USER = 'ADENOVO.USER'
const EXPIRE_INFO = 'ADENOVO.EXPIRE_INFO'

let idTokenCache: null | string = null

let isRefreshing = false

type ExpireInfo = {
  stamp: number
  expiresIn: number
}
const initExpireInfo = (): ExpireInfo => ({
  stamp: 0,
  expiresIn: 3600,
})

let lastExpireInfo: ExpireInfo = getItem(EXPIRE_INFO) || initExpireInfo()

export type User = {
  member_id: number
  aifian_id: string
  is_verified: 0 | 1
  ci_verified: 0 | 1
  reject_reason: string
  has_id_card_num: false
  email: string
  bacon_level: number
  cream_hash: string
  id_token?: string
  refresh_token?: string
  expires_in: number
  username: string
}

export function readUser(): User | null {
  return getItem(USER)
}

export function saveUser(user: User): void {
  try {
    setItem(USER, user)
    lastExpireInfo = {
      stamp: Date.now(),
      expiresIn: user.expires_in || 3600,
    }
    setItem(EXPIRE_INFO, lastExpireInfo)
  } catch (err) {
    console.error(err)
  }
}

export function onLogout(): void {
  idTokenCache = null
  removeItem(USER)
  lastExpireInfo = initExpireInfo()
  removeItem(EXPIRE_INFO)
  // clear guest info
  clearGuestInfo()
}

export function readExpireInfo(): ExpireInfo {
  return lastExpireInfo
}

export function setIsRefreshing(newValue: boolean): void {
  isRefreshing = newValue
}

export function readIdToken(): {
  isExpired: boolean
  isRefreshing: boolean
  idToken: string | null
} {
  const isExpired =
    (Date.now() - lastExpireInfo.stamp) / 1000 > lastExpireInfo.expiresIn
  if (!idTokenCache) {
    const user = getItem(USER) as User
    if (user && user.id_token) {
      idTokenCache = user.id_token
    }
  }
  return {
    isExpired,
    isRefreshing,
    idToken: idTokenCache,
  }
}

export function readRefreshTokenPayload(): {
  username: string
  refresh_token: string | undefined
} | null {
  const user = getItem(USER) as User
  if (user) {
    return {
      username: user.email,
      refresh_token: user.refresh_token,
    }
  }
  return null
}

const GUEST_COOKIE_KEY = 's_g_id'

export function readGuestInfo(): {
  memberId: number | null
  mobile: string | null
} {
  try {
    const info = cookieManager.read(GUEST_COOKIE_KEY)
    if (info) {
      const data = JSON.parse(info) as { i: number; m: string }
      return {
        memberId: data.i || null,
        mobile: data.m || null,
      }
    }
    throw new Error('the cookie not found.')
  } catch (e) {
    return { memberId: null, mobile: null }
  }
}

export function writeGuestInfo(memberId: string, mobile: string): void {
  cookieManager.write(
    GUEST_COOKIE_KEY,
    JSON.stringify({
      i: memberId,
      m: mobile,
    }),
  )
}

function clearGuestInfo() {
  cookieManager.clear(GUEST_COOKIE_KEY)
}
